export default __webpack_public_path__ + "static/media/undraw_wash_hands_nwl2.f901ca5f.svg";